const StatCounter = () => { return import(/* webpackChunkName: 'stat-counter' */ './StatCounter.vue'); };

export {
    StatCounter,
};
